(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-image-with-text"] && !Shopify.designMode) return;
  try {
    
  class StickyImageWithText extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.sticky-image-with-text__media');
      this.mediaCol = this.querySelector('.sticky-image-with-text__media-col');
      if (!this.media || !this.mediaCol) return;

      this.updateStickyPosition = this.updateStickyPosition.bind(this);
      this.updateStickyPosition();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.updateStickyPosition);
        this.resizeObserver.observe(this.media);
      }

      window.addEventListener('resize', this.updateStickyPosition, { passive: true });
      window.addEventListener('load', this.updateStickyPosition, { once: true });
    }

    updateStickyPosition() {
      const mediaHeight = this.media?.getBoundingClientRect().height || 0;
      if (mediaHeight <= 0) return;

      this.style.setProperty('--sticky-media-height', `${mediaHeight}px`);

      const topOffset = Math.max(0, (window.innerHeight - mediaHeight) / 2);
      this.mediaCol.style.setProperty('--top-custom', `${Math.round(topOffset)}px`);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.updateStickyPosition);
    }
  }

  if (!customElements.get('sticky-image-with-text')) {
    customElements.define('sticky-image-with-text', StickyImageWithText);
  }

  } catch(e) { console.error(e); }
})();
})();
